export function Checkbox({ name, triState, onChange }: any) {

    return (
        <input type="checkbox" name={name} checked={triState} onChange={onChange} />
    );
}